import { getPopularTripsAction } from "../../../Actions/LogicActions/Search/GetPopularTripsAction";
import { getBestPriceForDateRangeAction } from "../../../Actions/LogicActions/Search/GetBestPriceForDateRangeAction";
import { uiPreferencesAction } from "../../../Actions/LogicActions/Search/GetUIPreferencesAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { TrainTypeEnum } from "../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { isWidgetEnabled } from "../../../Lib/Utils/isWidgetEnabled";

export class PopularTripsStep extends StepFlow {
    get stepName() { return "PopularTripsStep"; }

    async onEventSetup(): Promise<void> {
        this.registerEventSubscription(
            _eventBus.on({
                eventName: evtTree.popularTrips.Get,
                handler: async () => {
                    if (!isWidgetEnabled("popularTrips")) return;
                    getPopularTripsAction.execute();
                }
            })
        );

        // Popular Trip cards open the shared SelectDateModal on the home page,
        // where DestinationDetailsFlow isn't running. Mirror its price fetch so
        // the calendar shows per-day best prices under each date.
        this.registerEventSubscription(
            _eventBus.on<{ startStop: string, endStop: string }, void>({
                eventName: evtTree.SelectDateModal.Open,
                handler: async ({ data }) => {
                    if (data) {
                        const { startStop, endStop } = data;
                        await uiPreferencesAction.execute();
                        const calendarDayInterval = uiPreferencesAction.result?.calendarDayInterval || 90;
                        getBestPriceForDateRangeAction.setParams({
                            from: startStop,
                            to: endStop,
                            type: TrainTypeEnum.outbound,
                            calendarDayInterval
                        });
                        await getBestPriceForDateRangeAction.execute();
                    }
                },
            })
        );
    }

    async onExecute(): Promise<void> {
        console.log("PopularTripsStep Init Step Execute...");

        this.eventBus.emit({
            eventName: evtTree.popularTrips.Get,
        });
    }
}
export const popularTripsStepDeclaration = new StepDefinition({
    stepName: "PopularTripsStep",
    stepClass: PopularTripsStep
});
